/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    FacetFiltersForm.syncSortSelects();
    FacetFiltersForm.syncPaginationLinks();

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static syncSortSelects() {
    const urlSort = new URLSearchParams(window.location.search).get('sort_by');
    const activeSort = (urlSort && urlSort !== 'manual') ? urlSort : 'manual';

    ['SortBy', 'SortByMobile'].forEach((id) => {
      const select = document.getElementById(id);
      if (!select) return;

      if (Array.from(select.options).some((option) => option.value === activeSort)) {
        select.value = activeSort;
      } else if (Array.from(select.options).some((option) => option.value === 'manual')) {
        select.value = 'manual';
      }

      window.dispatchEvent(new Event('resize.resize-select'));
    });
  }

  static syncPaginationLinks() {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.delete('page');
    if (currentParams.get('sort_by') === 'manual') {
      currentParams.delete('sort_by');
    }

    document.querySelectorAll('.page-numbers a').forEach((link) => {
      const href = link.getAttribute('href') || '';
      let page = null;

      try {
        page = new URL(href, window.location.origin).searchParams.get('page');
      } catch (e) {
        const match = href.match(/[?&]page=(\d+)/);
        page = match ? match[1] : null;
      }

      const params = new URLSearchParams(currentParams.toString());
      if (page && page !== '1') {
        params.set('page', page);
      }

      const query = params.toString();
      link.setAttribute('href', window.location.pathname + (query ? `?${query}` : ''));
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

    // Added by OCS - For color swatch color change on hover after filter applied
    document.querySelectorAll('.color_swatch li').forEach(function(swatch) {
      // Add mouseover event listener
      swatch.addEventListener('mouseover', function() {
          var imageUrl = this.dataset.imageUrl;
          var productContainer = this.closest('.product-card'); // Adjust the selector to match your product container
          var mainProductImage = productContainer.querySelector('.product-primary-image'); // Adjust the selector for the main product image
          mainProductImage.src = imageUrl;
          mainProductImage.srcset = imageUrl;
      });
  
      // Add mouseout event listener
      swatch.addEventListener('mouseout', function() {
          var masterUrl = this.closest('ul').querySelector('div.active_picker').dataset.imageUrl;
          var productContainer = this.closest('.product-card'); // Adjust the selector to match your product container
          var mainProductImage = productContainer.querySelector('.product-primary-image'); // Adjust the selector for the main product image
          mainProductImage.src = masterUrl;
          mainProductImage.srcset = masterUrl;
      });
  });
    
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }

    // Keep the active sort when applying filters. Desktop filter forms omit sort_by,
    // and mobile selects fall back to the first option when Featured/manual is active.
    // Featured (manual) stays as a clean URL with no sort_by query param.
    if (event.target && event.target.name === 'sort_by') {
      if (event.target.value === 'manual') {
        searchParams.delete('sort_by');
      } else {
        searchParams.set('sort_by', event.target.value);
      }
    } else {
      const urlSort = new URLSearchParams(window.location.search).get('sort_by');
      if (urlSort && urlSort !== 'manual') {
        searchParams.set('sort_by', urlSort);
      } else {
        searchParams.delete('sort_by');
      }
    }

    if (searchParams.get('sort_by') === 'manual') {
      searchParams.delete('sort_by');
    }

    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    const params = new URLSearchParams(url);
    if (params.get('sort_by') === 'manual') {
      params.delete('sort_by');
      url = params.toString();
    }
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

function initFacetSortState() {
  new FacetsToggle();
  FacetFiltersForm.syncSortSelects();
  FacetFiltersForm.syncPaginationLinks();
}

// Run as soon as DOM is ready (facets.js is deferred), don't wait for full page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFacetSortState);
} else {
  initFacetSortState();
}

// Keep sort/filters on pagination clicks even if links were rendered without them
document.addEventListener('click', (event) => {
  const link = event.target.closest('.page-numbers a');
  if (!link) return;

  FacetFiltersForm.syncPaginationLinks();
}, true);